<template>
  <div class="col-12">
    <v-row v-for="(period,index) in newSession.periods" :key="index" class="col-12">
      <v-col :cols="editable ? 4 : 2" class="d-flex justify-end align-center text-subtitle-1">
        Période {{ index+1 }}
      </v-col>
      <v-col :cols="editable ? 6 : 4" class="pr-0">
        <SessionTimesForm
          :start-time.sync="period.start"
          :end-time.sync="period.end"
          :editable="editable"
        />
      </v-col>
      <v-col v-if="!editable" cols="4" class="pr-0">
        <SelectPicker
          v-model="period.discipline"
          subtitle="Période Discipline"
          :items="disciplines"
          icon="mdi-lead-pencil"
          :return-object="true"
          :select-item="selectItem"
        />
      </v-col>
      <v-col class="d-flex align-center" cols="2">
        <Button
          icon="mdi-close"
          class="d-flex align-center font-weight-bold d-flex  justify-center full-height"
          :outlined="false"
          :setfullheight="true"
          :remove-margin="true"
          :color="null"
          :icon-color="null"
          :plain="true"
          :action="() => removePeriod(index)"
          :disabled="editable"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { inject, computed, ref } from '@vue/composition-api';

import Button from '@/components/common/Button.vue';
import SelectPicker from '@/components/common/Form/SelectPicker.vue';

import SessionTimesForm from './SessionTimesForm.vue';

import store from '@/store';

export default {
  components: { SessionTimesForm, Button, SelectPicker },
  setup () {
    const newSession = inject('newSession');
    const editable = inject('editable', false);

    const removePeriod = periodIndexToRemove => {
      newSession.value.periods.splice(periodIndexToRemove, 1);
    };

    const disciplines = computed(() => store.state.disciplines.map(d => ({ uuid: d.uuid, wtitle: d.name })));

    const selectItem = ref({
      value: 'uuid',
      label: 'wtitle'
    });

    return { newSession, removePeriod, editable, selectItem, disciplines };
  }
};

</script>
